import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import TableGrupos from './Tables/TableGrupos.js';
import { formatCurrency } from '../../../../functions/functions';

import api from "../../../../api";

import { Alert } from 'reactstrap';
import TableEjecutores from './Tables/TableEjecutores.js';
import CurrencyInput from '../../../../components/SafeCurrencyInput/SafeCurrencyInput.js';


const redImportes = (accumulator, currentValue) => (accumulator + currentValue.monto);

class Ejecutores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      funcionamientoPLQ: 40,
      ejecutores: 0,
      porcentajes: [],
      subtotal: 0,
      monto: 0,
      totalADistribuir: 0,
      montosADistribuir: [],

      errors: {},
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    id: PropTypes.func.isRequired,
  }


  getData() {
    const { montosADistribuir } = this.state;

    return {
      montosADistribuir: montosADistribuir.map((e, i) => ({
        id: e.id,
        grupo_id: e.grupo_id,
        personal_id: e.personal_id,
        porcentaje: e.porcentaje,
        monto: e.monto,
      })
      )
    };
  }

  setData = (data) => {

    this.setState({
      monto: data.monto,
      funcionamientoPLQ: data.funcionamientoPLQ,
      ejecutores: data.ejecutores,
      porcentajes: data.porcentajes,

      subtotal: data.subtotal,

      montosADistribuir: data.montoADistribuirSeparaciones.map((e, i) => ({ ...e, ...{ i: i } })),

      totalADistribuir: (data.monto - data.subtotal) * (data.ejecutores / 100),
      // totalADistribuir: (data.monto - data.subtotal) * ((100 - data.funcionamientoPLQ - data.ejecutores - porcentajes.reduce((pv, cv) => pv + cv.porcentaje, 0)) / 100)
    })
  }

  onValidation = () => {
    const { montosADistribuir, totalADistribuir } = this.state;

    let validate = true;
    let errors = { montosADistribuir: undefined };
    let montosADistribuirSubtotal = montosADistribuir.reduce(redImportes, 0);
    let subtotalGrupos = montosADistribuir.filter(x=>x.grupo_id != null).reduce((totalizador, x) => x.monto + totalizador, 0);

    let dif = totalADistribuir - montosADistribuirSubtotal;

    if ((Math.trunc(totalADistribuir) * 0.10) > subtotalGrupos) {
      validate = false;
      errors.montosADistribuir = 'Subtotal Grupos debe poseer como minimo el 10% del monto'
    // } else if ((montosADistribuir.length > 0) && 1 <= difTrunc) {
    } else if ((montosADistribuir.length > 0) && 0.99 < dif) {
      validate = false;
      errors.montosADistribuir = 'Debe asignar el 100% del monto'
    } else if (montosADistribuir.length > 0) {
      // montosADistribuir[0].monto = montosADistribuir[0].monto + dif
      montosADistribuir.filter(x => x.grupo_id != null)[0].monto += dif //Los centavos sobrantes deben ser asignados al primer grupo.
      validate = true;
    } else {
      errors.montosADistribuir = undefined;
    }

    this.setState({
      errors: errors,
    })

    return validate;
  }

  resetState = () => {
    this.setState({
      funcionamientoPLQ: 40,
      ejecutores: 0,
      porcentajes: [],
      subtotal: 0,
      monto: 0,
      totalADistribuir: 0,
      montosADistribuir: [],
      errors: {},
    })
  }


  onAddToTable = ({ personal_id, personal_nombre, grupo_id, grupo_nombre, porcentaje, importe }) => {
    let montosADistribuiraux = [...this.state.montosADistribuir];
    montosADistribuiraux.push({
      i: montosADistribuiraux.length,
      id: null,
      personal_id,
      personal_nombre,
      grupo_id,
      grupo_nombre,
      porcentaje: porcentaje,
      monto: importe
    });
    this.setState({ montosADistribuir: montosADistribuiraux, errors: {} })
  }

  removeRow = (i) => {
    let montosADistribuir = this.state.montosADistribuir.filter(r => r.i != i);
    montosADistribuir = montosADistribuir.map((e, i) => ({ ...e, ...{ i: i } }));
    this.setState({
      montosADistribuir: montosADistribuir,
    });
  }

  trunc = (n) => {
    let t = n.toString();
    let regex = /(\d*.\d{0,2})/;
    return parseFloat(t.match(regex)[0]);
  }

  render() {
    const {
      funcionamientoPLQ, subtotal, montosADistribuir,
      errors, totalADistribuir
    } = this.state;

    const montosADistribuirSubtotal = montosADistribuir.reduce(redImportes, 0);
    const saldo = totalADistribuir - montosADistribuirSubtotal;
    return (
      <ParadigmaModal
        getUrl={api.imputaciones.separacionImputaciones.edit}
        postUrl={api.imputaciones.separacionImputaciones.edit}
        onPreSubmit={() => this.getData()}
        onGotData={(data) => this.setData(data)}
        onClose={() => this.resetState() & (this.props.onClose && this.props.onClose())}
        onValidation={() => this.onValidation()}
        buttonTitle={"Distribuir Ejecutores"}
        title={"Distribuir Ejecutores"}
        onSubmit={() => { return true }}
        id={this.props.id}
        successMessage={"El Monto a Distribuir ha sido editado con éxito."}
        missingIdMessage={"Debe seleccionar una fila."}
        buttonIcon={"fa fa-user fa-lg"}
        saveButton={!((funcionamientoPLQ === 0) && (subtotal === 0))}
        closeButton={true}

        className={'ui-modal-dialog ui-modal-lg'}
      >
        {((funcionamientoPLQ === 0) && (subtotal === 0)) ?
          <div className="ui-form">
            <section className="ui-section-block">
              <h3 className={'text-center'}>{'La separación no fue detallada'}</h3>
            </section>
          </div>
          :
          <div className="ui-form">
            <section className="ui-section-block">
              <h5 className="ui-section-label">Resumen</h5>
                <ParadigmaLabeledInput
                  label={"Monto a distribuir"}
                  labelColumns={6}
                  fieldColumns={6}
                  inputComponent={
                    <CurrencyInput
                      disabled={true}
                      prefix={"$"}
                      className="form-control text-right"
                      defaultValue={0}
                      decimalsLimit={2}
                      maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }}
                      decimalSeparator=","
                      groupSeparator="."
                      value={formatCurrency(totalADistribuir)}
                    />}
                />
            </section>

            <TableGrupos
              totalADistribuir={totalADistribuir}
              montosADistribuir={montosADistribuir}
              sumaImportesMontos={montosADistribuirSubtotal}
              onAddToTable={(d) => this.onAddToTable(d)}
              onRemoveRow={(i) => this.removeRow(i)}
            />

            <TableEjecutores
              totalADistribuir={totalADistribuir}
              montosADistribuir={montosADistribuir}
              sumaImportesMontos={montosADistribuirSubtotal}
              onAddToTable={(d) => this.onAddToTable(d)}
              onRemoveRow={(i) => this.removeRow(i)}
            />

            <section className="ui-section-block">
              <div className="ui-summary-panel">
                <ParadigmaLabeledInput
                  disabled={true}
                  label={"Saldo"}
                  labelClassName={"text-right"}
                  type={"number"}
                  labelColumns={4}
                  fieldColumns={8}
                  value={formatCurrency(saldo.toString())}
                  onChange={() => { }}
                />
              </div>
            </section>
            <div className="mt-2">
                {(errors.montosADistribuir != null) &&
                  <Alert color={'danger'}>{errors.montosADistribuir}</Alert>}
            </div>
          </div>}

      </ParadigmaModal>
    );
  }
}

export default Ejecutores;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/ImputarModal/Ejecutores.js